import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.5 7c0-.644.522-1.166 1.167-1.166h18.666a1.167 1.167 0 1 1 0 2.333H4.667A1.167 1.167 0 0 1 3.5 7.001Zm0 7c0-.644.522-1.166 1.167-1.166h18.666a1.167 1.167 0 1 1 0 2.333H4.667A1.167 1.167 0 0 1 3.5 14.001Zm0 7c0-.644.522-1.166 1.167-1.166h18.666a1.167 1.167 0 1 1 0 2.333H4.667A1.167 1.167 0 0 1 3.5 21.001Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }